import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-refetch'
import { checkNextPropsPromiseFulfilled, connectDefault } from '../utils/utils'
import * as actions from '../actions/index'

class AppPage extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    appBaseURL: PropTypes.string.isRequired,
    ahBaseUrl: PropTypes.string.isRequired,
    channelType: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  }

  componentWillMount() {
    this.props.fetchAppJWT()
  }

  componentWillReceiveProps(nextProps) {
    //load of app
    if (checkNextPropsPromiseFulfilled(this.props, nextProps, 'app')) {
      const app = nextProps.app.value
      const appsTitles = {}
      appsTitles[app.id] = app.title
      this.props.dispatch(actions.addBreadcrumbsRouteTitles({'app':appsTitles}))
    }
    //load of app jwt
    else if (checkNextPropsPromiseFulfilled(this.props, nextProps, 'appJWT')) {
      this.props.fetchChannelTypes(nextProps.appJWT.value['jwt'])
    }
  }

  render() {
    let children = null;
    const { appBaseURL, ahBaseUrl, app, channelTypes, channelType, dispatch, appJWT, fetchCredentials } = this.props
    if (this.props.children && app.fulfilled && channelTypes && channelTypes.fulfilled && appJWT.fulfilled) {
      children = React.cloneElement(this.props.children, {
        appBaseURL: appBaseURL,
        ahBaseUrl: ahBaseUrl,
        appJWT: appJWT.value["jwt"],
        app: app.value,
        fetchApp: this.props.fetchApp,
        channelTypes: channelTypes.value,
        channelType: channelType,
        dispatch: dispatch,
        fetchCredentials: fetchCredentials
      })
    }

    return (
      <div>
        {children}
      </div>
    )
  }
}

export default connect.defaults(connectDefault)(props => {
  return {
    app: {
      title: 'Fetch App',
      dispatch: props.dispatch,
      url: props.appBaseURL
    },
    fetchApp: () => ({
      app: {
        title: 'Fetch App',
        dispatch: props.dispatch,
        url: props.appBaseURL,
        refreshing: true, force: true
      }
    }),
    fetchAppJWT: () => ({
      appJWT: {
        title: 'Fetch App JWT',
        dispatch: props.dispatch,
        url: `${props.appBaseURL}/credentials/jwt/token`,
        method: 'POST',
        body: {
          access: 'platform',
          grants: {
            assisthub: true
          }
        }
      }
    }),
    fetchChannelTypes: (appjwt) => ({
      channelTypes: {
        title: 'Fetch Channel Types',
        dispatch: props.dispatch,
        appJWT: appjwt,
        url:`${props.ahBaseUrl}/channeltypes`
      }
    }),
    fetchCredentials: (handler) => ({
    fetchCredentialsResponse: {
      title: 'Fetch Credentials',
      dispatch: props.dispatch,
      handler: handler,
      url:`${props.appBaseURL}/credentials`
    }
    })
  }
})(AppPage)



// WEBPACK FOOTER //
// ./src/containers/AppPage.js